
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"-35 0 512 512","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M74.668 102.5h30v42.668h-30zm0 0M149.332 102.5h30v42.668h-30zm0 0M74.668 187.832h30V230.5h-30zm0 0M149.332 187.832h30V230.5h-30zm0 0M74.668 273.168h30v42.668h-30zm0 0M149.332 273.168h30v42.668h-30zm0 0M74.668 358.5h30v42.668h-30zm0 0M149.332 358.5h30v42.668h-30zm0 0M292.664 187.832h30V230.5h-30zm0 0M292.664 273.168h30v42.668h-30zm0 0"}}),_c('path',{attrs:{"d":"M391.758 455.414c28.906-6.8 50.5-32.793 50.5-63.746 0-30.988-21.637-57-50.59-63.77v-225.73H254.156V42.695h-24.351V0H24.352v42.695H0V512l441.668-.168v-30h-49.91zM54.352 30h145.453v42.695h24.351v409.14H30V72.696h24.352zm199.804 102.168h107.512v195.773c-28.863 6.836-50.41 32.801-50.41 63.727 0 30.922 21.547 56.89 50.41 63.727v26.437H254.156zm158.102 259.5c0 19.574-15.926 35.5-35.5 35.5-19.578 0-35.5-15.926-35.5-35.5s15.922-35.5 35.5-35.5c19.574 0 35.5 15.926 35.5 35.5zm0 0"}})])
          )
        }
      }
    